export default class AudioResampler {
  constructor(numOfChannels, inSampleRate, outSampleRate, frameLength) {
    this.numOfChannels = numOfChannels;
    this.inSampleRate = inSampleRate;
    this.outSampleRate = outSampleRate;
    this.frameLength = frameLength;
  }

  process(data) {
    return new Promise((resolve, reject) => {
      const offlineCtx = new OfflineAudioContext(
        this.numOfChannels,
        this.outSampleRate * this.frameLength,
        this.outSampleRate
      );

      const cloneBuffer = offlineCtx.createBuffer(
        this.numOfChannels,
        this.inSampleRate * this.frameLength,
        this.inSampleRate
      );
      cloneBuffer.copyToChannel(data, 0, 0);

      const source = offlineCtx.createBufferSource();
      source.buffer = cloneBuffer;
      source.connect(offlineCtx.destination);
      source.start(0);

      offlineCtx
        .startRendering()
        .then((result) => resolve(result.getChannelData(0)))
        .catch(reject);
    });
  }
}
